// extracted by mini-css-extract-plugin
export default {"base":"CbsaStats_base__eqxxv","header":"CbsaStats_header__UcEk0"};